module.exports = __webpack_public_path__ + "static/media/bckbone.0595805b.webp";